export const FilterByParks = (datas, id) => {
    const parks = [];
    const univers = [[], []];
    const map = new Map();
    const sortDatas = (datas) => {
        datas.sort((a, b) => {
            if (a.uslug < b.uslug) return -1;
            if (a.uslug > b.uslug) return 1;
            return 0;
        });
    }
    if (datas.length > 0) {
        for (const el of datas) {
            /* park */
            if (!map.has(el.pslug) && el.pid === id) {
                map.set(el.pslug, true);
                parks.push({
                    pid: el.pid,
                    pname: el.pname,
                    pslug: el.pslug,
                    proute: el.proute,
                });
            }
            /* univers */
            for (let i = 0; i < parks.length; i++) {
                if (!map.has(el.uslug) && el.pid === id) {
                    map.set(el.uslug, true);
                    univers[i].push({
                        uid: el.uid,
                        uname: el.uname,
                        uslug: el.uslug,
                        uroute: el.uroute,
                    });
                }
                sortDatas(univers[i])
            }
        }
        for (let i = 0; i < parks.length; i++) {
            parks[i].univers = univers[i];
        }
    }
    return parks;
}